/**
 * How a DIAGNOSIS_LIST control arranges its entries. Mirrors the server's DiagnosisListLayout.
 *
 * VERTICAL is 0 deliberately: every template saved before this existed has no value for it, and an absent
 * value reads back as 0. That makes "stacked, one entry under the last" the default without special-casing,
 * which is what these controls have always printed.
 *
 * HORIZONTAL is codes only — a comma-separated run that wraps, the way a list of ICD-10 codes reads on a
 * referral or a billing note. Descriptions, comments and the numbering are deliberately dropped: those are
 * what the stacked layout is for, and a description containing a comma would make the separator ambiguous.
 * `displayDiagnosisDescription` therefore has no effect while HORIZONTAL is selected.
 */
export enum DiagnosisListLayout {
  VERTICAL = 0,
  HORIZONTAL = 1,
}
